<template>
  <div
    ref="el"
    class="close-button"
    @mouseenter="showTooltip"
    @mouseleave="hideTooltip"
  >
    <BaseButton kind="auxiliary" :class="tint" @click="$emit('click')">
      <template #icon>
        <CloseIcon />
      </template>
    </BaseButton>
  </div>
</template>
<script lang="ts">
import { defineComponent, onBeforeUnmount, PropType, ref } from "vue";

import BaseButton from "@/components/base/BaseButton.vue";
import type { Tint } from "@/components/base/types";
import CloseIcon from "@/components/icons/CloseIcon.vue";

import { useTooltip } from "../tooltip";

export default defineComponent({
  components: { BaseButton, CloseIcon },
  props: {
    tint: {
      type: String as PropType<Tint>,
      default: "none",
    },
    text: {
      type: String,
      default: "Cancel",
    },
    shortcut: {
      type: String as PropType<string | undefined>,
      default: undefined,
    },
  },
  emits: {
    click: () => true,
  },
  setup(props) {
    const el = ref<HTMLElement>();
    const { showTooltip, hideTooltip, release } = useTooltip(
      el,
      ref({ text: props.text, shortcut: props.shortcut }),
      "top"
    );
    onBeforeUnmount(release);
    return {
      el,
      hideTooltip,
      showTooltip,
    };
  },
});
</script>
<style lang="scss" scoped>
.close-button {
  :deep(path.fill) {
    @include transition(fill 100ms ease-out);
    @include themed() {
      fill: t($grey-50);
    }
  }
  :deep(&.blue path.fill) {
    @include transition(fill 100ms ease-out);
    @include themed() {
      fill: t($tertiary-50);
    }
  }
  :deep(&:hover path.fill) {
    @include transition(fill 100ms ease-out);
    @include themed() {
      fill: t($secondary);
    }
  }
}
</style>
